exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".app.is-atlas{overflow:hidden}@media (max-width:61.9275em){.app.is-atlas .hide-desktop{display:none}}@media (min-width:61.9375em){.app.is-atlas .show-desktop{display:none}}", ""]);
